var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"reference",on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[_c('div',{ref:"tooltip",class:[
        'tooltip bg-gray-600 my-0.5 px-2 py-0.5 text-sm rounded shadow-md text-center z-10',
        _vm.show ? 'block' : 'hidden',
        _vm.className,
      ]},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.arrow)?_c('div',{staticClass:"arrow",attrs:{"data-popper-arrow":""}}):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }